const initialState = {
    locations: [],

    fetching: false,
    fetched: false,
    error: null,
}

export function locationsMngtReducer(state = initialState, action) {

    switch (action.type) {
        case "FETCH_LOCATIONSMNGT_LIST_TOKEN": {
            return { ...state, fetching: true, fetched: false, error: null }
        }

        case "UPDATE_LOCATIONS":
        case "FETCH_LOCATIONSMNGT_LIST": {
            return { ...state, fetching: true, fetched: false, error: null }
        }

        case "UPDATE_LOCATIONS_REJECTED":
        case "FETCH_LOCATIONSMNGT_LIST_REJECTED": {
            return { ...state, fetching: false, error: action.payload }
        }

        case "UPDATE_LOCATIONS_FULFILLED": {
            var curLocs = Object.assign({}, state.locations)

            curLocs.holidayTypes = action.payload.data.holidayTypes
            curLocs.locationGroupTypes = action.payload.data.locationGroupTypes

            return { ...state, fetching: false, fetched: true, locations: curLocs }
        }

        case "FETCH_LOCATIONSMNGT_LIST_FULFILLED": {
            return { ...state, fetching: false, fetched: true, locations: action.payload.data }
        }

        case "NEW_LOCATION_OPTION": {
            var curLocations = Object.assign({}, state.locations)

            if (!curLocations[action.payload.data.location].filter((opt) => {
                return action.payload.data.location == 'holidayTypes' && opt.holidayTypeName == action.payload.data.option ||
                       action.payload.data.location == 'locationGroupTypes' && opt.locationGroupTypeName == action.payload.data.option
            }).length) {
                action.payload.data.location == 'holidayTypes' ?
                    curLocations[action.payload.data.location].push({ holidayTypeId: -1, holidayTypeName: action.payload.data.option, active: false }) :
                    curLocations[action.payload.data.location].push({ locationGroupTypeId: -1, locationGroupTypeName: action.payload.data.option, active: false })

                return { ...state, locations: curLocations }
            }
            else return state
        }

        case "ALL_LOCATION_OPTIONS": {
            var curLocations = Object.assign({}, state.locations)

            curLocations[action.payload.data.location].map((location) => {
                location.active = true
            })

            return { ...state, locations: curLocations }
        }

        case "SEL_LOCATION_OPTIONS": {
            var curLocations = Object.assign({}, state.locations)

            action.payload.data.options.map((selopt) => {
                curLocations[action.payload.data.location].map((opt) => {
                    if (opt.holidayTypeName && opt.holidayTypeName == selopt ||
                        opt.locationGroupTypeName && opt.locationGroupTypeName == selopt) {
                        opt.active = true
                    }
                })
            })

            return { ...state, locations: curLocations }
        }

        case "UNSEL_LOCATION_OPTION": {
            var curLocations = Object.assign({}, state.locations)

            curLocations[action.payload.data.location].map((opt) => {
                if (opt.holidayTypeName && opt.holidayTypeName == action.payload.data.option ||
                    opt.locationGroupTypeName && opt.locationGroupTypeName == action.payload.data.option) {
                    opt.active = false
                }
            })

            return { ...state, locations: curLocations }
        }

        case "NO_LOCATION_OPTIONS": {
            var curLocations = Object.assign({}, state.locations)

            curLocations[action.payload.data.location].map((location) => {
                location.active = false
            })

            return { ...state, locations: curLocations }
        }

        case "FETCH_LOCATIONSMNGT_ERROR": {
            return { ...state, error: null }
        }

        case "LOCATIONSMNGT_ERROR": {
            return { ...state, error: null }
        }

        default:
            return state
    }
}
